import { IconMiniButton } from 'components/FbUI/FbButton'
import { CreateCompanyModal } from './CreateCompanyModal'
import { PiPlus } from 'react-icons/pi'
import { useMemo, useState } from 'react'
import useApiService from '../../../services/api'
import { CompanyTypeSlug } from '../../../models/companies'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export default function CreateCompanyButton(props: {
  companyTypeSlug: CompanyTypeSlug
}) {
  const [show, setShow] = useState(false)
  const variant = useTableLinkVariant()

  const api = useApiService()
  const { data: categories } = api.useGetActiveCompanyCategoriesAndTypes()

  const cat = useMemo(() => {
    let cat: { category_id: number; sub_category_id: number } | null = null
    outer: for (const c of categories ?? []) {
      for (const s of c.sub_categories) {
        if (s.slug === props.companyTypeSlug) {
          cat = {
            category_id: c.id,
            sub_category_id: s.id,
          }
          break outer
        }
      }
    }
    return cat
  }, [categories, props.companyTypeSlug])

  if (!cat) {
    return null
  }

  return (
    <>
      <IconMiniButton
        variant="secondary"
        onClick={() => setShow(true)}
        className={
          variant === 'plain'
            ? '!border-neutral-300 !text-neutral-800 hover:!bg-neutral-100 hover:!text-neutral-900'
            : undefined
        }
      >
        <PiPlus size={14} />
      </IconMiniButton>
      <CreateCompanyModal
        show={show}
        setShow={setShow}
        defaultValues={{
          category: cat.category_id,
          sub_category: cat.sub_category_id,
        }}
      />
    </>
  )
}
